<template>
  <v-container class='pt-6'>
    <v-card class='elevation-12 mb-6'>
      <v-card-title class='px-9 pt-7'>
        Přílohy rámcových smluv
        <v-radio-group
          class='px-9 pt-2'
          v-model='voltageLevel'
          row>
          <v-radio
            label='NN'
            value='NN'
          ></v-radio>
          <v-radio
            label='VN'
            value='VN'
          ></v-radio>
        </v-radio-group>
      </v-card-title>
      <v-card-text class='pb-0 overflow-hidden'>
        <v-row
          v-if='notAvailable'
          class='agreement-attachment-header py-3'>
          <v-col
            cols='12'
            class='px-8 d-flex align-center request-value'>
            <template v-if='agreementAttachment.actual.noInstallations'>
              Příloha není k dispozici, protože odběrná místa vašich zákazníků nejsou na této
              napěťové
              hladině.
            </template>
            <template v-else>
              Příloha není k dispozici
            </template>
          </v-col>
        </v-row>
        <v-row v-else class='agreement-attachment-header py-3'>
          <v-col cols='9' class='px-8 d-flex align-center request-value'>
            Aktuální příloha rámcové smlouvy:
            <a
              class='ml-3'
              :href='agreementAttachment.actual.url'
              @click.prevent='fileDownload($event, agreementAttachment.actual.uuid)'
            >
              {{ agreementAttachment.actual.name }}
            </a>
          </v-col>
          <v-col cols='3' class='px-8 d-flex align-center'
                 v-if='agreementAttachment.actual.complaint'>
            <v-chip class='white--text' color='#781717' label>
              V REKLAMACI
            </v-chip>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <TableAgreementAttachment
          v-model='agreementAttachment'
          @onChangeOptions='loadAgreementAttachment'
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { setFilters } from '@/components/mixins/setFilters';
import { downloadFile } from '@/components/mixins/downloadFile';
import TableAgreementAttachment from '@/components/tables/TableAgreementAttachment.vue';
import { mapActions } from 'vuex';

export default {
  name: 'AgreementAttachment',
  mixins: [setFilters, downloadFile],
  components: {
    TableAgreementAttachment,
  },
  data() {
    return {
      dialog: {
        content: '',
        show: false,
        data: {},
      },
      agreementAttachment: {
        actual: {},
        selected: [],
        items: [],
        options: {
          page: 1,
          itemsPerPage: this.$store.state.settings.tables.agreementAttachmentList.itemsPerPage,
          sortBy: ['created'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
        month: '',
        created: '',
        url: '',
        errorMessage: '',
      },
      cancel: null,
      interval: null,
      baseUrl: process.env.VUE_APP_BACKEND,
      voltageLevel: 'NN',
    };
  },
  methods: {
    ...mapActions({
      getAgreementAttachmentsHistorical: 'requests/getAgreementAttachmentsHistorical',
    }),
    fileDownload(event, uuid) {
      this.downloadFile(event, `requests/files/${uuid}`);
    },
    loadAgreementAttachment() {
      this.agreementAttachment.loading = true;
      const searchParams = {
        filterParams: {
          voltageLevel: this.voltageLevel,
        },
      };
      if (this.cancel) {
        this.cancel();
        this.cancel = null;
      }
      searchParams.cancelHandler = (cancel) => {
        this.cancel = cancel;
      };

      this.getAgreementAttachmentsHistorical(searchParams)
        .then((response) => {
          this.agreementAttachment.items = response.data.history;
          this.agreementAttachment.actual = response.data.actual;

          this.cancel = null;
        })
        .finally(() => {
          this.agreementAttachment.loading = false;
        });
    },
  },
  computed: {
    notAvailable() {
      return this.agreementAttachment.actual.noInstallations
        || this.agreementAttachment.actual.notAvailable;
    },
  },
  watch: {
    '$route.query': {
      handler() {
        if (this.$route.query.level) {
          this.voltageLevel = this.$route.query.level;
        }
        this.loadAgreementAttachment();
      },
    },
    voltageLevel() {
      this.$router.push({
        name: 'agreementAttachment',
        query: { level: this.voltageLevel },
      });
    },
  },
  mounted() {
    if (this.$route.query.level) {
      this.voltageLevel = this.$route.query.level;
    }
  },
  created() {
    this.loadAgreementAttachment();
  },
};
</script>

<style lang='scss'>
.agreement-attachment-header {
  background: #e7e9ef;
}

.v-card__text {
  .agreement-attachment-header {
    margin-left: -16px;
    margin-right: -16px;
  }
}
</style>
